import {
  BarChart, Bar, LineChart, Line, PieChart, Pie, Cell, XAxis, YAxis,
  CartesianGrid, Tooltip, ResponsiveContainer,
} from "recharts";
import { Megaphone } from "lucide-react";
import { GRAYS, ChartTooltip } from "./shared";

export function OverviewTab({ stats }) {
  return (
    <div className="grid lg:grid-cols-2 gap-6">
      <div className="rounded-lg border border-white/10 bg-card p-6">
        <h3 className="text-sm uppercase tracking-luxe text-muted-foreground mb-6">Pipeline Value Over Time</h3>
        <ResponsiveContainer width="100%" height={260}>
          <LineChart data={stats.timeseries}>
            <CartesianGrid strokeDasharray="3 3" stroke="#27272a" />
            <XAxis dataKey="date" stroke="#71717a" fontSize={11} />
            <YAxis stroke="#71717a" fontSize={11} />
            <Tooltip content={<ChartTooltip />} />
            <Line type="monotone" dataKey="value" name="Pipeline $" stroke="#ffffff" strokeWidth={2} dot={{ r: 3, fill: "#fff" }} />
          </LineChart>
        </ResponsiveContainer>
      </div>

      <div className="rounded-lg border border-white/10 bg-card p-6">
        <h3 className="text-sm uppercase tracking-luxe text-muted-foreground mb-6">Lead Sources</h3>
        <ResponsiveContainer width="100%" height={260}>
          <PieChart>
            <Pie data={stats.leads_by_source} dataKey="value" nameKey="name" cx="50%" cy="50%"
              outerRadius={90} innerRadius={50} paddingAngle={2}>
              {stats.leads_by_source.map((entry, i) => <Cell key={entry.name} fill={GRAYS[i % GRAYS.length]} />)}
            </Pie>
            <Tooltip content={<ChartTooltip />} />
          </PieChart>
        </ResponsiveContainer>
        <div className="flex flex-wrap gap-3 mt-4">
          {stats.leads_by_source.map((l, i) => (
            <span key={l.name} className="flex items-center gap-2 text-xs text-muted-foreground">
              <span className="h-2.5 w-2.5 rounded-full" style={{ background: GRAYS[i % GRAYS.length] }} />
              {l.name} ({l.value})
            </span>
          ))}
        </div>
      </div>

      <div className="rounded-lg border border-white/10 bg-card p-6">
        <h3 className="text-sm uppercase tracking-luxe text-muted-foreground mb-6">Bookings by Service</h3>
        <ResponsiveContainer width="100%" height={260}>
          <BarChart data={stats.bookings_by_service}>
            <CartesianGrid strokeDasharray="3 3" stroke="#27272a" />
            <XAxis dataKey="name" stroke="#71717a" fontSize={11} />
            <YAxis stroke="#71717a" fontSize={11} allowDecimals={false} />
            <Tooltip content={<ChartTooltip />} cursor={{ fill: "#ffffff10" }} />
            <Bar dataKey="value" name="Bookings" fill="#ffffff" radius={[4, 4, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>

      <div className="rounded-lg border border-white/10 bg-card p-6">
        <h3 className="text-sm uppercase tracking-luxe text-muted-foreground mb-6">Booking Status</h3>
        <ResponsiveContainer width="100%" height={260}>
          <BarChart data={stats.status_breakdown} layout="vertical">
            <CartesianGrid strokeDasharray="3 3" stroke="#27272a" />
            <XAxis type="number" stroke="#71717a" fontSize={11} allowDecimals={false} />
            <YAxis type="category" dataKey="name" stroke="#71717a" fontSize={11} width={90} />
            <Tooltip content={<ChartTooltip />} cursor={{ fill: "#ffffff10" }} />
            <Bar dataKey="value" name="Count" fill="#a1a1aa" radius={[0, 4, 4, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>

      <div className="rounded-lg border border-white/10 bg-card p-6 lg:col-span-2">
        <div className="flex items-center gap-2 mb-6">
          <Megaphone className="h-4 w-4 text-muted-foreground" />
          <h3 className="text-sm uppercase tracking-luxe text-muted-foreground">Marketing Campaigns (UTM)</h3>
        </div>
        {stats.leads_by_campaign && stats.leads_by_campaign.length > 0 ? (
          <ResponsiveContainer width="100%" height={240}>
            <BarChart data={stats.leads_by_campaign}>
              <CartesianGrid strokeDasharray="3 3" stroke="#27272a" />
              <XAxis dataKey="name" stroke="#71717a" fontSize={11} />
              <YAxis stroke="#71717a" fontSize={11} allowDecimals={false} />
              <Tooltip content={<ChartTooltip />} cursor={{ fill: "#ffffff10" }} />
              <Bar dataKey="value" name="Leads" fill="#ffffff" radius={[4, 4, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        ) : (
          <p className="text-muted-foreground text-sm py-8 text-center">
            No campaign data yet. Share links with UTM tags (e.g. ?utm_source=instagram&utm_campaign=summer) to track which ads drive bookings.
          </p>
        )}
      </div>
    </div>
  );
}
